import React from 'react'
import Nav from '../components/Nav'
import Header from '../components/Header'

import Footer from '../components/Footer'

function Home() {
  return (
    <div >


      <Nav />

      <Header />
    
      

          <Footer />

        </div>
        )
}

        export default Home